import { CustomFieldValueDto } from './dto/custom-field-value.dto';
import { Injectable } from '@angular/core';
import { ApiService, PagedResultGeneric, PagedSearch } from '../../shared/index';
import { PagedResult as GenericPagedResult } from '../../shared/model/generic-paged-result.model';
import { CustomFieldDto } from './dto/custom-field.dto';

@Injectable({
  providedIn: 'root',
})
export class CustomFieldService {
  public _apiService: ApiService;
  public constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  public searchCustomFields(searchDto?: PagedSearch, forceRefresh?: boolean): Promise<PagedResultGeneric<CustomFieldDto>> {
    const url = '/Profile/CustomFields';
    const searchParams = searchDto ? searchDto : ({ PageSize: 0, PageNumber: 0 } as PagedSearch);
    const cacheOptions = forceRefresh ? this._apiService.getDefaultApiCacheOptionsForNoCache() : null;
    return this._apiService.getPaged(url, searchParams, cacheOptions);
  }

  public getCustomFieldValues(customFieldId: number): Promise<CustomFieldValueDto[]> {
    return this._apiService.get(`/Profile/CustomFields/${customFieldId}/AvailableValues`);
  }

  public get(id: number): Promise<CustomFieldDto> {
    return this._apiService.get(`/Profile/CustomField/${id}`);
  }

  public create(dto: CustomFieldDto): Promise<CustomFieldDto> {
    dto.AvailableOnWebsite = dto.AvailableOnWebsite ? 1 : 0;
    return this._apiService.post('Profile/CustomField', dto);
  }

  public upsert(dto: CustomFieldDto): Promise<void> {
    dto.AvailableOnWebsite = dto.AvailableOnWebsite ? 1 : 0;
    return this._apiService.post('Profile/CustomFieldUpsert', dto);
  }

  public update(dto: CustomFieldDto): Promise<void> {
    dto.AvailableOnWebsite = dto.AvailableOnWebsite ? 1 : 0;
    return this._apiService.put('Profile/CustomField', dto);
  }

  public delete(id: number): Promise<void> {
    return this._apiService.delete(`Profile/CustomField/${id}`);
  }
}
